import { useState } from 'react'
import { Filter, Search, X } from 'lucide-react'
import { TimeFilters } from '../tipos/time'

interface FiltrosTimeProps {
  onSearch: (filters: TimeFilters) => void
}

export function FiltrosTime({ onSearch }: FiltrosTimeProps) {
  const [filters, setFilters] = useState<TimeFilters>({ search: '' })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onSearch(filters)
  }

  const handleClear = () => {
    const cleared: TimeFilters = { search: '' }
    setFilters(cleared)
    onSearch(cleared)
  }

  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-theme-sm mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-r from-brand-500 to-brand-600 rounded-lg flex items-center justify-center">
            <Filter className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">Filtros de Time</h3>
            <p className="text-sm text-gray-600">Busque times por descrição</p>
          </div>
        </div>
        <button
          type="button"
          onClick={handleClear}
          className="px-3 py-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-all duration-200 font-medium"
        >
          <X className="w-4 h-4 mr-2 inline" />
          Limpar
        </button>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-wrap items-end gap-4">
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700 mb-2">Buscar</label>
          <div className="relative">
            <input
              type="text"
              value={filters.search || ''}
              onChange={(e) => setFilters((p) => ({ ...p, search: e.target.value }))}
              className="w-full px-3 py-2 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all duration-200"
              placeholder="Buscar por descrição..."
            />
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          </div>
        </div>
        <button
          type="submit"
          className="px-4 py-2 text-white bg-brand-500 rounded-lg hover:bg-brand-600 transition-all duration-200 font-medium"
        >
          <Search className="w-4 h-4 mr-2 inline" />
          Buscar Times
        </button>
      </form>
    </div>
  )
}
